import { ReportConfig } from "../definitions";

const annualGrowthTrend: ReportConfig = {
  id: "annual-growth-trend",
  name: "Annual Growth Trend",
  options: [
    {
      name: "businessType",
      label: "Business type",
      dataType: "select",
      options: [
        { key: "All", value: "all" },
        { key: "FPO", value: "fpo" },
        { key: "YTD FPO", value: "fpoytd" },
        { key: "YTD All", value: "allytd" },
      ],
    },
  ],
  layout: [
    {
      items: [
        {
          id: "paid-premium-chart",
          title: "Paid Premium (in thousands)",
          widgetType: "bar",
          columns: [
            { name: "Placed", type: "currency" },
            { name: "Projection", type: "currency" },
          ],
          dataSource: {
            sql: `
            -- init
            declare @dayofyear int
            set @dayofyear = datepart(DAYOFYEAR,getdate())
            if right(@businessType, 3) <> 'ytd' set @dayofyear=366 --for YTD compare the dayofyear. when YTD option is not set just compare to 366 (for leap years)

            declare @projectionMultiplier float = 365.0 / datepart(dayofyear, getdate());

            if @businessType='all'
            BEGIN
              SELECT 1998 as [Year], 0.001 * 482409.09 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 1999 as [Year], 0.001 * 1043637.75 [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2000 as [Year], 0.001 * 984727.76 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2001 as [Year], 0.001 * 1613518.35 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2002 as [Year], 0.001 * 2631385.86 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2003 as [Year], 0.001 * 3294414.19 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2004 as [Year], 0.001 * 3181172.16 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2005 as [Year], 0.001 * 4216292.96 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2006 as [Year], 0.001 * 3842255.09 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2007 as [Year], 0.001 * 4925388.59 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2008 as [Year], 0.001 * 6664851.24 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2009 as [Year], 0.001 * 5485390.12 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2010 as [Year], 0.001 * 5257095.90 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT 2011 as [Year], 0.001 * 5097366.22 as [TotalPremiumSum], 0 as [Projection] UNION
              SELECT
                  YEAR([awu].[Application].[PaidOrClosedDate]) AS [Year],
                  SUM([awu].[ApplicationPremium].[AnnualizedPremium]) / 1000 AS [TotalPremiumSum],
                  IIF(
                    YEAR([awu].[Application].[PaidOrClosedDate]) = YEAR(GETDATE()),
                    (SUM([awu].[ApplicationPremium].[AnnualizedPremium]) / 1000) * (@projectionMultiplier - 1),
                    0) AS [Projection]
              FROM [awu].[Application]
                  LEFT JOIN [awu].[ApplicationPremium] ON [awu].[Application].[ID] = [awu].[ApplicationPremium].[ApplicationID]
                  LEFT JOIN [awu].[ApplicationStatus] ON [awu].[Application].[ApplicationStatusID] = [awu].[ApplicationStatus].[ID]
              WHERE [awu].[Application].[PaidOrClosedDate] IS NOT NULL
                  AND [awu].[ApplicationStatus].[ApplicationStatusCode] in ('2', '3', 'P')
                  AND [awu].[ApplicationStatus].[ScenarioTypeCode] = 'F'
                  AND [awu].[Application].[PaidOrClosedDate] >= '2012-01-01'
                  -- apply branch filter if provided
                  AND (@_branch = 0 OR [awu].[Application].branchTypeID = @_branch)
              GROUP BY YEAR([awu].[Application].[PaidOrClosedDate])
              ORDER BY [Year]
            END

            ELSE IF LEFT(@businessType,3) = 'fpo'

            BEGIN --fpo and fpoytd
              SELECT
                YEAR([awu].[Application].[PaidOrClosedDate]) AS [Year],
                --COUNT([awu].[Application].[ID]) as [TotalApplications],
                SUM(ISNULL([awu].[ApplicationPremium].[AnnualizedPremium], 0)) / 1000 AS [TotalPremiumSum],
                IIF(
                    YEAR([awu].[Application].[PaidOrClosedDate]) = YEAR(GETDATE()),
                    (SUM(ISNULL([awu].[ApplicationPremium].[AnnualizedPremium], 0)) / 1000) * (@projectionMultiplier - 1),
                    0) AS [Projection]
              FROM [awu].[Application]
                  LEFT JOIN [awu].[ApplicationPremium] ON [awu].[Application].[ID] = [awu].[ApplicationPremium].[ApplicationID]
                  LEFT JOIN [awu].[ApplicationStatus] ON [awu].[Application].[ApplicationStatusID] = [awu].[ApplicationStatus].[ID]
                  LEFT JOIN [awu].[ApplicationAdditionalInfo] ON [awu].[Application].[ID] = [awu].[ApplicationAdditionalInfo].[ApplicationID]
              WHERE [awu].[Application].[PaidOrClosedDate] IS NOT NULL
                  AND [awu].[ApplicationStatus].[ApplicationStatusCode] in ('2', '3', 'P')
                  AND [awu].[ApplicationStatus].[ScenarioTypeCode] = 'F'
                  AND [awu].[Application].[PaidOrClosedDate] >= '2017-01-01'
                  AND DATEPART(DAYOFYEAR, [awu].[Application].[PaidOrClosedDate]) <= @dayofyear
                  AND [awu].[ApplicationAdditionalInfo].[ProposalNumber] = 111
                  -- apply branch filter if provided
                  AND (@_branch = 0 OR [awu].[Application].branchTypeID = @_branch)
              GROUP BY YEAR([awu].[Application].[PaidOrClosedDate])
              ORDER BY [Year]
            END

            ELSE

            BEGIN --allytd
              SELECT
                YEAR([awu].[Application].[PaidOrClosedDate]) AS [Year],
                -- COUNT([awu].[Application].[ID]) as [TotalApplications],
                SUM(ISNULL([awu].[ApplicationPremium].[AnnualizedPremium], 0)) / 1000 AS [TotalPremiumSum],
                IIF(
                    YEAR([awu].[Application].[PaidOrClosedDate]) = YEAR(GETDATE()),
                    (SUM(ISNULL([awu].[ApplicationPremium].[AnnualizedPremium], 0)) / 1000) * (@projectionMultiplier - 1),
                    0) AS [Projection]
              FROM [awu].[Application]
                  LEFT JOIN [awu].[ApplicationPremium] ON [awu].[Application].[ID] = [awu].[ApplicationPremium].[ApplicationID]
                  LEFT JOIN [awu].[ApplicationStatus] ON [awu].[Application].[ApplicationStatusID] = [awu].[ApplicationStatus].[ID]
              WHERE [awu].[Application].[PaidOrClosedDate] IS NOT NULL
                  AND [awu].[ApplicationStatus].[ApplicationStatusCode] in ('2', '3', 'P')
                  AND [awu].[ApplicationStatus].[ScenarioTypeCode] = 'F'
                  AND [awu].[Application].[PaidOrClosedDate] >= '2017-01-01'
                  AND DATEPART(DAYOFYEAR, [awu].[Application].[PaidOrClosedDate]) <= @dayofyear
                  -- apply branch filter if provided
                  AND (@_branch = 0 OR [awu].[Application].branchTypeID = @_branch)
              GROUP BY YEAR([awu].[Application].[PaidOrClosedDate])
              ORDER BY [Year]
            END
              `,
            returnType: "table",
          },
          options: { stack: "total", colors: ["#234980", "#92B3E3"] },
        },
      ],
    },
    {
      items: [
        {
          id: "paid-premium-table",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Placed", type: "string" },
            { name: "Policies", type: "number", summary: "sum" },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
            { name: "Change", type: "percent", align: "right" },
          ],
          dataSource: {
            sql: `

-- for debugging
-- declare @businessType VARCHAR
-- set @businessType = 'all'

declare @dayofyear int
set @dayofyear = datepart(DAYOFYEAR,getdate())
if right(@businessType, 3) <> 'ytd' set @dayofyear=366 --for YTD compare the dayofyear. when YTD option is not set just compare to 366 (for leap years)

declare @projectionMultiplier float = 365.0 / datepart(dayofyear, getdate());

if @businessType='all'
BEGIN
    WITH YearlyData AS (
      SELECT 1998 as [Year], 253 as [TotalApplications], 482409.09 as [TotalAnnualizedPremium] UNION
      SELECT 1999 as [Year], 856 as [TotalApplications], 1043637.75 [TotalAnnualizedPremium] UNION
      SELECT 2000 as [Year], 563 as [TotalApplications], 984727.76 as [TotalAnnualizedPremium] UNION
      SELECT 2001 as [Year], 793 as [TotalApplications], 1613518.35 as [TotalAnnualizedPremium] UNION
      SELECT 2002 as [Year], 1147 as [TotalApplications], 2631385.86 as [TotalAnnualizedPremium] UNION
      SELECT 2003 as [Year], 1450 as [TotalApplications], 3294414.19 as [TotalAnnualizedPremium] UNION
      SELECT 2004 as [Year], 1386 as [TotalApplications], 3181172.16 as [TotalAnnualizedPremium] UNION
      SELECT 2005 as [Year], 2094 as [TotalApplications], 4216292.96 as [TotalAnnualizedPremium] UNION
      SELECT 2006 as [Year], 1991 as [TotalApplications], 3842255.09 as [TotalAnnualizedPremium] UNION
      SELECT 2007 as [Year], 3297 as [TotalApplications], 4925388.59 as [TotalAnnualizedPremium] UNION
      SELECT 2008 as [Year], 3948 as [TotalApplications], 6664851.24 as [TotalAnnualizedPremium] UNION
      SELECT 2009 as [Year], 3024 as [TotalApplications], 5485390.12 as [TotalAnnualizedPremium] UNION
      SELECT 2010 as [Year], 2330 as [TotalApplications], 5257095.90 as [TotalAnnualizedPremium] UNION
      SELECT 2011 as [Year], 2087 as [TotalApplications], 5097366.22 as [TotalAnnualizedPremium] UNION
      SELECT
          YEAR([a].[PaidOrClosedDate]) AS [Year],
          COUNT([a].[ID]) AS [TotalApplications],
          SUM([ap].[AnnualizedPremium]) AS [TotalAnnualizedPremium]
      FROM [awu].[Application] [a]
      INNER JOIN [awu].[ApplicationStatus] [ast] ON [a].[ApplicationStatusID] = [ast].[ID]
      INNER JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
      WHERE
          ([a].IsDeleted IS NULL OR [a].IsDeleted = 0)
          AND PaidOrClosedDate >= '2012-01-01'
          AND [a].[PaidOrClosedDate] IS NOT NULL
          AND [ast].[Description] IN ('In Force', 'In Force - Commission Paid', 'In Force With Requirements')
          -- apply branch filter if provided
          AND (@_branch = 0 OR [a].branchTypeID = @_branch)
      GROUP BY YEAR([a].[PaidOrClosedDate])
    ),
    YearlyDataWithLag AS (
    SELECT
        [Year],
        [TotalApplications],
        [TotalAnnualizedPremium],
        LAG([TotalAnnualizedPremium]) OVER (ORDER BY [Year]) AS [PreviousYearPremium]
    FROM YearlyData
    )
    SELECT
        CAST([Year] AS VARCHAR) as [Year],
        [TotalApplications],
        [TotalAnnualizedPremium],
        CASE
            WHEN [PreviousYearPremium] IS NULL THEN NULL
            WHEN [PreviousYearPremium] = 0 THEN NULL
            ELSE (([TotalAnnualizedPremium] - [PreviousYearPremium]) / [PreviousYearPremium])
        END AS [PercentageChangeFromPreviousYear]
    FROM YearlyDataWithLag

    UNION

    SELECT
        'Projection' as [Year],
        FLOOR([TotalApplications] * @projectionMultiplier),
        [TotalAnnualizedPremium] * @projectionMultiplier,
        CASE
            WHEN [PreviousYearPremium] IS NULL THEN NULL
            WHEN [PreviousYearPremium] = 0 THEN NULL
            ELSE ((([TotalAnnualizedPremium] * @projectionMultiplier) - [PreviousYearPremium]) / [PreviousYearPremium])
        END AS [PercentageChangeFromPreviousYear]
    FROM YearlyDataWithLag
    WHERE [Year] = YEAR(GETDATE())

    UNION

    SELECT
        'Total',
        SUM([TotalApplications]),
        SUM([TotalAnnualizedPremium]),
        NULL
    FROM YearlyDataWithLag

    ORDER BY [Year]

END
ELSE IF LEFT(@businessType,3) = 'fpo'
BEGIN --fpo and fpoytd
  WITH YearlyData AS (
    SELECT
    YEAR([awu].[Application].[PaidOrClosedDate]) AS [Year],
    COUNT([awu].[Application].[ID]) as [TotalApplications],
    SUM(ISNULL([awu].[ApplicationPremium].[AnnualizedPremium], 0)) AS [TotalPremiumSum]
    FROM [awu].[Application]
        LEFT JOIN [awu].[ApplicationPremium] ON [awu].[Application].[ID] = [awu].[ApplicationPremium].[ApplicationID]
        LEFT JOIN [awu].[ApplicationStatus] ON [awu].[Application].[ApplicationStatusID] = [awu].[ApplicationStatus].[ID]
        LEFT JOIN [awu].[ApplicationAdditionalInfo] ON [awu].[Application].[ID] = [awu].[ApplicationAdditionalInfo].[ApplicationID]

    WHERE [awu].[Application].[PaidOrClosedDate] IS NOT NULL
        AND [awu].[ApplicationStatus].[ApplicationStatusCode] in ('2', '3', 'P')
        AND [awu].[ApplicationStatus].[ScenarioTypeCode] = 'F'
        AND [awu].[Application].[PaidOrClosedDate] >= '2017-01-01'
        AND DATEPART(DAYOFYEAR, [awu].[Application].[PaidOrClosedDate]) <= @dayofyear
        AND [awu].[ApplicationAdditionalInfo].[ProposalNumber] = 111
        -- apply branch filter if provided
        AND (@_branch = 0 OR [awu].[Application].branchTypeID = @_branch)
    GROUP BY YEAR([awu].[Application].[PaidOrClosedDate])
    -- ORDER BY [Year] -- invalid in this context
  ),
  YearlyDataWithLag AS (
  SELECT
      [Year],
      [TotalApplications],
      [TotalPremiumSum],
      LAG([TotalPremiumSum]) OVER (ORDER BY [Year]) AS [PreviousYearPremium]
  FROM YearlyData
  )
  SELECT
      CAST([Year] AS VARCHAR) as [Year],
      [TotalApplications],
      [TotalPremiumSum],
      CASE
          WHEN [PreviousYearPremium] IS NULL THEN NULL
          WHEN [PreviousYearPremium] = 0 THEN NULL
          ELSE (([TotalPremiumSum] - [PreviousYearPremium]) / [PreviousYearPremium])
      END AS [PercentageChangeFromPreviousYear]
  FROM YearlyDataWithLag

  UNION

  SELECT
      'Projection' as [Year],
      FLOOR([TotalApplications] * @projectionMultiplier),
      [TotalPremiumSum] * @projectionMultiplier,
      CASE
          WHEN [PreviousYearPremium] IS NULL THEN NULL
          WHEN [PreviousYearPremium] = 0 THEN NULL
          ELSE ((([TotalPremiumSum] * @projectionMultiplier) - [PreviousYearPremium]) / [PreviousYearPremium])
      END AS [PercentageChangeFromPreviousYear]
  FROM YearlyDataWithLag
  WHERE [Year] = YEAR(GETDATE())

  UNION

  SELECT
      'Total',
      SUM([TotalApplications]),
      SUM([TotalPremiumSum]),
      NULL
  FROM YearlyDataWithLag

  ORDER BY [Year]
END
ELSE
BEGIN --allytd
  WITH YearlyData AS (
    SELECT
    YEAR([awu].[Application].[PaidOrClosedDate]) AS [Year],
    COUNT([awu].[Application].[ID]) as [TotalApplications],
    SUM(ISNULL([awu].[ApplicationPremium].[AnnualizedPremium], 0)) AS [TotalPremiumSum]
    FROM [awu].[Application]
        LEFT JOIN [awu].[ApplicationPremium] ON [awu].[Application].[ID] = [awu].[ApplicationPremium].[ApplicationID]
        LEFT JOIN [awu].[ApplicationStatus] ON [awu].[Application].[ApplicationStatusID] = [awu].[ApplicationStatus].[ID]
    WHERE [awu].[Application].[PaidOrClosedDate] IS NOT NULL
        AND [awu].[ApplicationStatus].[ApplicationStatusCode] in ('2', '3', 'P')
        AND [awu].[ApplicationStatus].[ScenarioTypeCode] = 'F'
        AND [awu].[Application].[PaidOrClosedDate] >= '2017-01-01'
        AND DATEPART(DAYOFYEAR, [awu].[Application].[PaidOrClosedDate]) <= @dayofyear
        -- apply branch filter if provided
        AND (@_branch = 0 OR [awu].[Application].branchTypeID = @_branch)
    GROUP BY YEAR([awu].[Application].[PaidOrClosedDate])
  ),
  YearlyDataWithLag AS (
  SELECT
      [Year],
      [TotalApplications],
      [TotalPremiumSum],
      LAG([TotalPremiumSum]) OVER (ORDER BY [Year]) AS [PreviousYearPremium]
  FROM YearlyData
  )
  SELECT
      CAST([Year] AS VARCHAR) as [Year],
      [TotalApplications],
      [TotalPremiumSum],
      CASE
          WHEN [PreviousYearPremium] IS NULL THEN NULL
          WHEN [PreviousYearPremium] = 0 THEN NULL
          ELSE (([TotalPremiumSum] - [PreviousYearPremium]) / [PreviousYearPremium])
      END AS [PercentageChangeFromPreviousYear]
  FROM YearlyDataWithLag

  UNION

  SELECT
      'Projected',
      FLOOR([TotalApplications] * @projectionMultiplier),
      [TotalPremiumSum] * @projectionMultiplier,
      CASE
          WHEN [PreviousYearPremium] IS NULL THEN NULL
          WHEN [PreviousYearPremium] = 0 THEN NULL
          ELSE ((([TotalPremiumSum] * @projectionMultiplier) - [PreviousYearPremium]) / [PreviousYearPremium])
      END AS [PercentageChangeFromPreviousYear]
  FROM YearlyDataWithLag
  WHERE [Year] = YEAR(GETDATE()) -- to show current year even if no data

  UNION

  SELECT
      'Total',
      SUM([TotalApplications]),
      SUM([TotalPremiumSum]),
      NULL
  FROM YearlyDataWithLag

  ORDER BY [Year]
END
            `,
            returnType: "table",
          },
          options: { summaryInData: true, summaryRows: 2 },
        },
      ],
    },
  ],
};

export default annualGrowthTrend;
